import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTarget1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTarget1"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12.75 6V10.5H11.25V6H12.75ZM13.5 11.25V12.75H18V11.25H13.5ZM12.75 13.5V18H11.25V13.5H12.75ZM6 11.25V12.75H6.75H10.5V11.25H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTarget1;
